const contentObj = {
	JaaGa: "JaaGa",
	JaaGaDescription:
		"To be the first choice of our customers and partners in getting documents, legal help for any property they want to check before buy, sell and getting loan.",
	Welcome: "Welcome",
	JaaGaBlogQuote:
		"One Stop Destination for all Real Estate Related Information and Blogs..",
	JaaGaLandingCaption: "India's leading property Management Services",
	ContactTitle:
		"JaaGa at your service to help you on all property related documents and legal services at one stop.",
	LocateSaveManageProperty: "Find, Save and Manage Your Property",
	JoinAs: "Join as",
	Join: "Join",
	Customer: "Customer",
	ServicePartner: " Partner",
	LanguagePreference: "Language Preference",
	ChooseLanguageOfYourFirstPreference:
		"Choose language of your first preference",
	Continue: "Continue",
	PhoneNumber: "Phone Number",
	EnterYourPhoneNumberWithCountryCode:
		"Enter your phone number along with country code",
	RequestOTP: "Request OTP",
	EnterYourCode: "Enter Your Code",
	EnterThe6DigitOTP:
		"Enter the 6 digit OTP that was sent to your phone number ending in",
	SecondsRemaining: "Seconds Remaining",
	ResendOTP: "Resend OTP",
	Verify: "Verify",
	WelcomeToJaaGa: "Welcome To JaaGa Family",
	createMpin: "Create  MPIN",
	confirmMpin: "Confirm MPIN",
	CompleteYourProfile: "Complete Your Profile",
	EnterPropertyAddress: "Enter Property Address",
	MyProperties: "My Properties",
	Dashboard: "Dashboard",
	Documents: "Documents",
	OurServices: "Our Services",
	Legal: "Legal",
	Mediation: "Mediation",
	Mediate: "Mediate",
	HowItWorks: "How it Works",
	MasterData:
		"Complete Your Property Master Data to streamline property management and ensure smooth access to personalized services.",
	RealEstateKnowledge: "Real Estate Knowledge",
	SiteMap: "Site Map",
	TakeJaaGa: "Take JaaGa with you",
	DownloadOurApp: "Download our top-rated app, made just for you!",
	ItsFreeEasySmart: " It’s free, easy and smart.",
	SendAppLink: "Send App link",
	ShowQR: "Show QR code to get link",
	GetStarted: "Get Started",
	WhatCustomersSaying: "What our Customers are saying",
	News: "News",
	Blog: "Blog",

	// Rent:"Rent",
	Sell: "Sell",
	ListedForSell: "Listed For Sell",
	Listings: "My Listings",
	Deals: "Deals",
	Home: "Home",
	AboutUs: "About Us",
	Help: "Help",
	Login: "Login",
	Edit: "Edit",
	Save: "Save",
	Alerts: "Alerts",
	ReferAFriend:"Refer & Earn",
	ServiceStatus: "Service Status",
	Services: "Services",
	Settings: "Settings",
	Search: "Search",
	SearchForLocation: "Search Location",
	Logout: "Logout",
	DownloadApp: "Download App",
	DownloadMobileApp: "Download Mobile App",
	FollowUs: "Follow Us",
	Loans: "Loans",
	Buy: "Buy",

	Rent: "Rent",
	Maintain: "Maintain",
	HowJaaGaWorks: "How JaaGa Works",
	TimetoSaveyourProperty: "It's Time to Save your Property",
	LoginHere: "Login Here",
	SaveProperty: "Save Property",
	WhyisSaveProperty: "Why is Save Property",
	ContactUs: "Contact Us",
	Payments: "Payments",
	TermsOfUse: "Terms & Conditions",
	RefundCancellationPolicy: "Cancellation & Refund Policy",
	ShipDeliveryPolicy: "Ship & Delivery policy",
	CookiePolicy: "Cookie Policy",
	PrivacyPolicy: "Privacy Policy",
	AllRightsReserved: "JaaGa. All rights reserved",
	MyPropertyDescription: "All your property information in your hands",
	ManageEase: "Manage with ease",
	SafeAndSecure: "100% Safe and Secure",
	FreeOfCost: "Free of cost",
	DocumentsServices: "Document Services",
	DocumentsServicesDescription:
		"One-stop solution for all your property documents",
	GetDocumentInstantly: "Get any document instantly",
	CheckCorrection: "Check for correction",
	IncreasePropertyValue: "Increase your property value",
	LegalServices: "Legal Services",
	LegalDescription: "Any Legal problem can be addressed by ",
	TopNotchExperts: "Top notch Legal Experts",
	TimelyDependable: "Timely and dependable",
	PracticalSolution: "Practical Solution",
	MoreServices: "Services",
	MoreServicesDescripton: "Take control of your property right now",
	PropertyBinders: "Property Binders",
	PropertyReports: "Property Reports",
	RegistrationServices: "Registration Services",
	PersonalInfo: "Personal Info",
	UploadYourID: "Upload Your ID's here",
	ServicesProvided: "Services",
	UpdateServicesProvided: "Select a Service From Services",
	UpdateNomineeDetailsHere: "Update Nominee Details Here",
	AboutMe: "About Me",
	KYC: "KYC",
	KYCTitle: "Complete Your KYC",
	KnowYourCustomer: "Know Your Customer",
	MyNominee: "My Nominee",
	AddNominee: "Add Nominee",
	NomineeDetails: "Nominee Details",
	UpdateYourDetailsHere: "Update your photo and personal details here",
	SerivesProvided: "Serives Provided",
	ClickToUpload: "Click to Upload",
	DragAndDrop: "or drag and drop SVG, PNG, JPG or GIF(max.800 X 400px)",
	Name: "Name",
	RateLimitError: "Too many requests, please try again later.",
	WriteMessage: "What are you looking for, document or service?",
	Submit: "Submit",
	LeaveUsAMessage: "Leave Us A Message",
	EnterYourName: "Enter Your Name",
	SelectCategory: "Select Category",
	Category: "Category",
	name: "Name",
	FirstName: "First Name",
	LastName: "Last Name",
	EnterYourFirstName: "Enter Your First Name",
	EnterYourLastName: "Enter Your Last Name",
	MiddleName: "Middle Name",
	EnterYourMiddleName: "Enter Your Middle Name",
	FirstNameShould: "First Name Should be Between 3 TO 20 characters",
	MiddleNameShould: "MiddleName Name Should less than 20 characters",
	LastNameShould: "Last Name Should be Between 3 TO 20 characters",
	EnterNomineeFirstName: "Enter Nominee First Name",
	EnterNomineeMiddleName: "Enter Nominee Middle Name",
	EnterNomineeLastName: "Enter Nominee Last Name",
	RegisteredPhoneNumber: "Registered Phone Number",
	AlternatePhoneNumber: "Alternate Phone Number",
	EmailAddress: "Email Address",
	EnterYourEmailAddress: "Enter Your Email Address",
	EnterNomineeEmailAddress: "Enter Nominee Email Address",
	EmailisNotValid: "Email is Not Valid",
	Address1: "Address 1",
	PresentAddress: "Present Address",
	AddressLine1: "Address Line 1",
	ContactNumber: "Contact Number",
	SearchState: "Search States",
	SearchDocuments: "Search Documents",
	Area: "Area",
	EnterArea: "Enter Area",
	EnterStreet: "Enter Street",
	PropertyType: "Property Type",
	EnterPropertyType: "Enter Property Type",
	DocumentNumber: "Document Number",
	EnterDocumentNumber: "Enter Document Number",
	SurveyNumber: "Survey Number",
	EnterSurveyNumber: "Enter Survey Number",
	PlotNumber: "Plot Number",
	EnterPlotNumber: "Enter Plot Number",
	EnterOwnerName: "Enter Owner Name",
	StreetAddress: "Street Address",
	FloorBuildingBlockName: "F.No, Floor, Building or Block Name",
	HouseNoBuilding: "House No., Building, etc.",
	GetItNow: "Get it now",
	TalkToAgent: "Talk to agent",
	Proceed: "Proceed",
	AddressLine1ShouldBe:
		"Address Line 1 Should be Between 3 TO 350 characters",
	StreetNameRoadNo: "Street Name or Road No",
	Country: "Country",
	EnterYourCountry: "Enter Your Country",
	PleaseEnteraValidCountry: "Country Should be Between 3 TO 50 characters",
	State: "State",
	EnterYourState: "Enter Your State",
	PleaseEnteraValidstate: "State Should be Between 3 TO 50 characters",
	City: "City",
	EnterYourCity: "Enter Your City",
	EnterFullName: "Enter Full Name",
	FullName: "Full Name",
	CityShouldHave: "City Should be Between 3 TO 50 characters",
	PinCode: "Pin Code",
	PleaseEnterValidPincode: "Please Enter a Valid Pincode",
	PermanentSamePresent: "Permanent address same as present address",
	Yes: "Yes",
	No: "No",
	AddressPermanentHomeCountry: "Address 2 / Permanent / Home Country Address",
	Address2: "Address 2",
	IdentificationID: "Identification ID",
	ChooseID: "Choose ID from the List",
	Add: "Add",
	VERIFIED: "VERIFIED",
	NOTVERIFIED: "NOT VERIFIED",
	Delete: "Delete",
	Your: "Your",
	DataHasBeenDeleted: "Data Has been deleted successfully",
	DetailsHasBeenUpdated: "Details Has been Updated",
	AddIDNoAndUploadDocument: "Please Add ID No. and Upload Document",
	DetailsHasBeenAdded: "Details Has been Added",
	ImageURLCopied: "Document URL copied to clipboard",
	EnterIdNumber: "Enter Id Number",
	Relationship: "Relationship",
	SelectRelationship: "Select Relationship",
	PleaseEnterNomineeRelationship: "Please Enter Nominee Relationship",
	NomineeStatus: "Nominee Status",
	SelectStatus: "Select Status",
	PleaseSelectStatus: " Status Cannot Be Empty",
	AddImgToast: "Please Add Doccument ",
	ImgshareWarning: "Something went wrong",
	docShare: "Link is Valid Until Next 24 Hours",
	SwitchCustomer: "Switch to Cusotmer",
	SwitchPartner: "Switch to Partner",
	AllProperties: "All Properties",
	NoPropertyAvillable: "No Property avillable",
	CreateYourFirstProperty:
		"Please create your first property by clicking on below button",
	PropertyInformation: "Property Information",
	AddDescription:
		"Please choose the below options, Which type property you wanted to listed",
	AddProperty: "Add Property",
	Apartment: "Apartment",
	Land: "Land",
	HouseVilla: "HouseVilla",
	PropertyName: "Property Name",
	PropertyDescription: "Property Description (Optional)",
	AddNameToProperty: "Add a name to your Property",
	AddDescriptionForProperty: "Add Description for your property",
	Location: "Location",
	LocationDescription:
		"Is this the correct location of your property? If not, drag the pin to the correct location.",
	HouseFlatBuilding: "House, flat, building, etc...",
	AreaVillage: "Area/village",
	NearbyLandmark: "Nearby landmark",
	CityTown: "City / Town",
	Records: "Records",
	SupportFiles: "Files Supported: PDF, Doc, XSLS , Image,Scanner",
	PhotosVideo: "Photos and Video ",
	UploadAtleast: "Upload atleast 3 images & 1 video",
	ChooseFiles: "Choose files",
	DragandDropImages: "Drag and drop Images or",
	ToUpload: "to upload ",
	uploaded: "You have Uploaded the",
	TotalUploaded: "Total Uploaded",
	OnlySizeForImages: "Only JPEG, PNG, GIF  with max size of 3 mb",
	ImageDimensions: "Image Dimensions: Width(1200) x Height (700)",
	AddVideoURL: "Enter Video URL",
	AddVideoLink: "Add Video Link",
	AddVideoUrl: "Paste Youtube Video URL Here",
	UploadedGallary: "Uploaded Gallary",
	Upload: "Upload the",
	Congratulations: "Congratulations",
	PropertyAdded: "Your property has been successfully Added!",
	OK: "OK",
	Step1: "Category",
	Step2: "Address",
	Step3: "Property Info",
	Step4: "Photos and Video",
	PropertyNameWarning: "Property Name Must be between 3 and 150 characters",
	subCatergorySelecteError: "Sub Category is not Editable",
	manditoryTypeofPropertyError: "Please select Type of Your Property",
	PropertyDescriptionWarning:
		"Property description Must be between below 2000  characters",
	addressLine1Warning: "Should be 3 to 350 characters",
	areaWarning: "Should be 3 to 150 characters",
	streetWarning: "Should be 3 to  150 characters",
	landmarkWarning: "Should be 3 to 150 characters",
	stateWarning: "Should be 3 to 30 characters",
	cityWarning: "Should be 3 to 30 characters",
	countryWarning: "Should be 3 to 30 characters",
	pincodeWarning: "Below 12 characters",
	DeleteDocSuccess: "Document Deleted Successfully",
	UploadDocSuccess: "Document Uploaded Successfully",
	ShareDocLink: "Copied  Link Will Expire within 24 Hours",
	EditProperty: "Edit Property",
	SearchByLocation: "Search By Location",
	SearchByName: "Search By Name",
	// testmimonial Objects start
	Testimonialname01: "Akhila Priya",
	Testimonialaddress01: "Hyderabad, India",
	Testimonialdescription01:
		"JaaGa's assistance was a lifesaver when we forgot our property details. Within the same day, they efficiently retrieved all the required documents, ensuring a hassle-free experience.",
	Testimonialname02: "Srinivas G ",
	Testimonialaddress02: "Vizag, India",
	Testimonialdescription02:
		"The property binder from JaaGa was extremely helpful for me. It combined all my essential property documents into one organized and easily accessible binder, simplifying the entire management process.",
	Testimonialname03: "Sai Sekhar Reddy.M",
	Testimonialaddress03: "Guntur , Andhra Pradesh",
	Testimonialdescription03:
		"I was really impressed with how easy Jaaga made it to get important documents like my EC, Sale Deed, and Passbook. The whole process was smooth and hassle-free, and I didn’t have to run around or deal with delays. Their team was super reliable, and the best part, it was all done at a very reasonable cost. It saved me so much time and stress!",
		Testimonialname04: "Kondanna",
		Testimonialaddress04: "Hyderabad , Telangana",
		Testimonialdescription04:
			"I took Jaaga’s Title Verification Report service for my property, and it exceeded my expectations.They checked the title thoroughly and also provided my Sale Deed and Mutation records without any hassle.Their legal team was super helpful and made the entire process stress-free. A must-try for anyone looking for trusted and cost-effective property verification services!",
	// testmimonial Objects end
	Testimonialname05: "Chandra Sekhar .J",
		Testimonialaddress05: "Hyderabad , Telangana",
		Testimonialdescription05:"I used Jaaga’s PTIN Creation service for my new property, and the process was seamless.They handled everything with GHMC and ensured my property was properly registered for tax. I didn’t have to worry about the paperwork or follow-ups, they took care of it all. Highly recommend it for anyone needing a new PTIN or tax record correction!",
	LoginTitle: "Login/Signup",
	OTPVerification: "OTP Verification",
	ResendIn: "Resend in",
	SaveYourProperty: "Save your Property",
	LoginDescription: "One-stop destination for all property related services",
	NoFee: "No monthly fees.",
	DigitalSignup: "100% digital signup.",
	CustomerSupport: "24/7 customer support.",
	AccountTypeText: "Choose account type",
	OTPText: "OTP sent to",
	DocUploadPlaceHolder: "of your property",
	prev: "prev",
	next: "next",
	Use_my_current_location: "User my current location",
	Search_Address: "Search Address",
	CompulsoryDocuments: "Compulsory",
	goodToHave: "Good to Have",
	Others: "Other",
	CopiedLink: "Your link copied to clipboard",
	expiryMsg1: "This link is valid for 24 hours only.",
	expiryMsg30days: "This link is valid for 30 Days only.",

	expiryMsg2: "You can paste this link or share with.",
	msgtoPrivate1: "Do You Own this Property Now?",
	msgtoPrivate2: "Please Contact JaaGa to Claim Ownership",
	documentSearchPlaceholder: "Search state / documents",
	claim: "claim Ownership",
	NoVideoinPublic: "Video Not Avilable",
	NoVideoinPrivate: "Click Here to Add Video",
	deleteVideo: "Do you want to delete this Video",
	cancel: "Cancel",
	phoneNotValid: "Phonne Number is Not Valid",
	UpdateNomineePic: "Click here to Update Your Picture",
	CharacetersError: "First name should contain alphabets only.",
	MiddleNameErrror: "Middle Name should contain alphabets only.",
	LastNameError: "Last Name should contain alphabets only.",
	addAddress1: "Add your delivery address",
	selectAddress1: "Select your delivery address",
	addAddress2: "Will be used for delivery communications",
	addAddress3: "Save Address as -",
	addAddress4:
		"Address with this Label Already Exists. Please use Different Label",
	addAddress5: "Others",
	addAddress6: "home",
	addAddress7: "work",
	addAddress8: "family",
	addAddress9: "Add new Address",
	addAddress10: "Continue",
	addAddress11: "Save Address",
	documents1: "Clear Selection",
	documents2: "Other States",
	documents3: "Contact Us for other Document Services.",
	documents4: "Preview Not  Available",
	documents9: "Other Documents",
	Overview: "Overview",
	History: "History",
	Credits: "Credits",
	Invoices: "Invoices",
	MyAddresses: "My Addresses",
	Transactions: "Transactions",
	OrderDocument: "Order Document",
	HelpAndgettingstarted: "Help & getting started",
	TotalOrders: "Total Orders",
	TotalCompletedOrders: "Total Completed Orders",
	TotalPendingOrders: "Total Pending Orders",
	TotalCredits: "Total Credits",
	Hrs: "24 Hrs",
	Default: "Default",
	All: "All orders",
	Reset: "Reset",
	oneDay: "1 Day",
	oneWeek: "1 Week",
	oneMonth: "1 Month",

	/*documents Hero section */
	Request: "Request",
	and: "and",
	Get: "Get",
	the_documents_of_any_property: "documents of any property",
	Get_all_documents_at_your_convenience_of_location:
		"Access all the documents for your convenient location.",
	OwnerName: "Owner Name",
	PropertyDescriptionInfo: "Property Description",
	stateRestrctions: "We support only Telangana & Andhra Pradesh now",

	RealEstateServices: "Real Estate Services",
};
export default contentObj;
